import React, { Component } from "react";
import { getClientId } from "./utils/analyticsclientIdUtils";
import { encryptData } from "./utils/encryptionUtils";

if (typeof window !== "undefined") {
    window.webviewAuthentication = async function (jsonData) {
        try {
            const data = JSON.parse(jsonData);

            const token = data.token;
            const switchBackUrl = data.switchBackUrl;
            const refUserId = data.refUserId;

            const timestamp = Math.floor(Date.now() / 1000);
            const payload = {
                token: token,
                switchBackUrl: switchBackUrl,
                refUserId: refUserId,
                partnerCode: "002",
                Timestamp: timestamp
            };

            const encryptedPayload = encryptData(payload);

            const response = await fetch(`/api/ZPartnerLinkTokenVerify`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
            });

            const result = await response.json();

            if (result.responseCode === "00") {
                const ruid = result.refUserId || "";
                const sb = result.switchBackUrl || "";
                window.location.replace(`/X02LINEMAN/Home/?refUserId=${encodeURIComponent(ruid)}&switchBackUrl=${encodeURIComponent(sb)}`);
            } else {
                const message = result.responseMessage || "failed";
                window.location.replace(`/X02LINEMAN/Error/?S=${encodeURIComponent(message)}`);
            }
        } catch (err) {
            window.location.replace(`/X02LINEMAN/Error/?S=${encodeURIComponent(String(err))}`);
        }
    };
}

export class ZPartner02 extends Component {
    static displayName = ZPartner02.name;

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach((href) => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });

        const documentPath = "Partner02_Index";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });
    }

    render() {
        return (
            <>
                <div></div>
            </>
        );
    }
}
